import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

import icn_vision from '../../assets/img/landingPage/about/aboutUs_vision.svg';

import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'

//key Features
import key01 from '../../assets/img/landingPage/logistics/logistics-01.png';
import key02 from '../../assets/img/landingPage/connectors/Connectors_03.png';
import key03 from '../../assets/img/landingPage/logistics/logistics-03.png';
import key04 from '../../assets/img/landingPage/logistics/logistics-04.png';
import key05 from '../../assets/img/landingPage/logistics/logistics-05.png';

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/cloud/Cloud-home.png';


const Logistics = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'Real-time shipment visibility',
            text: "Track shipments, containers, and vehicles in real time with integrated GPS, IoT, and carrier systems, and expose that data to customers via secure APIs.",
            altDescription: "Track shipments, containers, and vehicles in real time with integrated GPS, IoT, and carrier systems, and expose that data to customers via secure APIs.",
            image: key01,
        },
        Key_Feature_02: {
            title: "Connect legacy systems to cloud platforms",
            text: "Use AVAP’s connectors and orchestrators to link outdated infrastructure with modern logistics apps, ERPs, and marketplaces, no heavy lifting required.",
            altDescription: "Connect legacy systems, CRMs, ERPs, and cloud services in seconds using AVAP Connectors — without coding or rewriting APIs. Query and trigger data from any system and orchestrate outcomes using AVAP Flow, our low-code automation builder.",
            image: key02,
        },
        Key_Feature_03: {
            title: 'Automate fleet and route operations',
            text: 
            "Streamline route planning, driver scheduling, vehicle maintenance, and incident reporting using API-first workflows and intelligent triggers.",
            altDescription: 'Design workflows where human input meets AI action.',
            image: key03,
        },
        Key_Feature_04: {
            title: 'Enable partner and customer self-service',
            text: 
            "Build secure API portals for brokers, shippers, and partners to access documentation, quote rates, and track deliveries, improving engagement and reducing manual work.",
            altDescription: 'Design workflows where human input meets AI action.',
            image: key04,
        },
        Key_Feature_05: {
            title: 'Support omnichannel logistics',
            text: 
            "Synchronize data and workflows across e-commerce, retail, and warehouse systems to manage cross-channel fulfillment, returns, and delivery expectations at scale.",
            altDescription: 'Design workflows where human input meets AI action.',
            image: key05,
        },
    }
    
    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" className="text-center py-5">
                    <h1 className="fl-title-big m-0">AVAP for Logistics</h1>
                    <p className="fl-title m-0 gradient-text">Streamline operations, boost delivery speed, <br/>and unlock data-driven logistics.</p>
                                

                    {/*Boton Contact Us*/}  
                    <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                </section>

                {/* Subtítulo descripción */}
                <section className="text-center pb-5">
                    {/* <img
                        src={dashboard}
                        className="img-fluid mt-2"
                        style={{ width: '70%', maxWidth: '800px', height: 'auto' }}
                    />*/}
                        <p className="fl-text fl-txt-container-s pt-6" >
                                AVAP Framework helps logistics providers integrate systems, partners, and platforms through modern APIs, accelerating transformation across the entire supply chain.
                                </p>
               
                </section>

                  
                <div className="container text-center fl-card-border p-6">
                    <h2 style={{ marginTop: '40px' }} className="fl-title m-0 gradient-text fl-title m-4">Why AVAP for Logistics?</h2>
                    
                    <p className="fl-text fl-txt-container-s">
                    As logistics ecosystems grow more complex, agility and visibility are no longer optional. AVAP gives you a unified API-based platform to connect and automate operations, from warehouse to last-mile delivery. 
                    </p>
                    <br/>
                    <br/>
                    <p className="fl-subtitle">With AVAP, you can<p/> 
                    {/* Sección Bullets */}
                    <ul className="fl-text fl-txt-container-s">
                        <li className="fl-bullets">Automate cargo tracking, fleet updates, and shipment notifications.</li>
                        <li className="fl-bullets">Connect legacy TMS, WMS, and ERP systems to modern platforms.</li>
                        <li className="fl-bullets">Optimize partner onboarding and data exchange with reusable APIs.</li>
                        <li className="fl-bullets">Deliver real-time visibility to customers, drivers, and operations teams.</li>
                        <li className="fl-bullets">Launch new logistics services faster with pre-built components and low-code tools.</li> </ul>
                    </p>
                </div>

                {/* Sección Key Features */}
                <div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                            {/*   <h3 className="fl-title text-center">Our Products & Services</h3> */}
                            <br />
                            &nbsp;
                            <br />&nbsp;
                            <p className="fl-title-center m-0">Key Capabilities</p> 
                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-6">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>

               {/* {/* Sección Key Benefits */}   
               {/* <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col  mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                
                                <p className="fl-subtitle-xs">
                                    Speed without technical debt
                                </p>
                                <p className="fl-text">
                                Build reusable, scalable automation that integrates and adapts without starting from scratch.

                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                               
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                     Boost productivity across teams
                                </p>
                                <p className="fl-text">
                                    Free your people from repetitive tasks and help AI agents act with accuracy.
                                    <br />&nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                               
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                    Deliver better outcomes, faster
                                </p>
                                <p className="fl-text">
                                    Surface the right data at the right time — every time.

                                </p>
                            </div>
                        </div>
                    </div>
                </section> */}

                {/* Sección built for secure */} 
                <section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4 text-center">

                                <div className="blob"></div>
    

                                <div className="">
                                    <h3 className='fl-title'>Ready to transform your logistics infrastructure?</h3>
                                    <p>AVAP can help you accelerate development, reduce costs, and drive innovation across your supply chain.
                                    </p>
                                {/*Boton Contact Us*/}  
                                <a className="glowBtn-dark " 
                                    style={{ zIndex: 2}} 
                                    href="/contact" 
                                    target='_blank'><span className="btnInner">Contact Us</span></a> 
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default Logistics;
